import { render } from "./HowItWorksVoucherShoutPanel.vue?vue&type=template&id=edfd0c02&scoped=true"
const script = {}

import "./HowItWorksVoucherShoutPanel.vue?vue&type=style&index=0&id=edfd0c02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfd0c02"]])

export default __exports__